// extracted by mini-css-extract-plugin
module.exports = {"container":"_2md9W6XlOooZ_2PXp7ClsV","restaurantsList":"_3yQYxzYTehKbN9WDcd1RbR"};